export default "__VITE_ASSET__BSGJ72lC__"